// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center"
      >
        <h4
          class="MuiTypography-root MuiTypography-h4"
        >
          No eligible claims
        </h4>
      </div>
      <p
        class="MuiTypography-root MuiTypography-body1"
      >
        Please create a claim for this patient. 
      </p>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center"
      >
        <div
          class="MuiCardActions-root MuiCardActions-spacing"
        >
          <a
            aria-disabled="false"
            class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
            href="/patients/1/billing_records/new"
            tabindex="0"
          >
            <span
              class="MuiButton-label"
            >
              New Claim
            </span>
            <span
              class="MuiTouchRipple-root"
            />
          </a>
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-text"
            tabindex="0"
            type="button"
          >
            <span
              class="MuiButton-label"
            >
              Cancel
            </span>
            <span
              class="MuiTouchRipple-root"
            />
          </button>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center"
    >
      <h4
        class="MuiTypography-root MuiTypography-h4"
      >
        No eligible claims
      </h4>
    </div>
    <p
      class="MuiTypography-root MuiTypography-body1"
    >
      Please create a claim for this patient. 
    </p>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-center"
    >
      <div
        class="MuiCardActions-root MuiCardActions-spacing"
      >
        <a
          aria-disabled="false"
          class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
          href="/patients/1/billing_records/new"
          tabindex="0"
        >
          <span
            class="MuiButton-label"
          >
            New Claim
          </span>
          <span
            class="MuiTouchRipple-root"
          />
        </a>
        <button
          class="MuiButtonBase-root MuiButton-root MuiButton-text"
          tabindex="0"
          type="button"
        >
          <span
            class="MuiButton-label"
          >
            Cancel
          </span>
          <span
            class="MuiTouchRipple-root"
          />
        </button>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
